// client/src/components/auth/AccountCreatedModal.js
import { Modal, Button } from 'react-bootstrap'
import './AccountCreatedModal.css'

/**
 * Modal dialog shown after successful account creation
 * Provides clear confirmation and next steps for users
 *
 * @param {boolean} show - Whether modal is visible
 * @param {string} email - User's email address
 * @param {function} onContinue - Handler for continue button (navigates to home)
 */
export default function AccountCreatedModal({ show, email, onContinue }) {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      className="account-created-modal"
    >
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="w-100 text-center">
          <div className="success-icon mb-3">✓</div>
          <h3 className="mb-0">Welcome to Serve Sync!</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center pt-2 pb-4">
        <p className="lead mb-3">Your account has been created successfully.</p>
        <p className="mb-2">We've sent a verification email to:</p>
        <p className="email-display mb-3">
          <strong>{email}</strong>
        </p>
        <p className="text-muted small mb-0">
          Please check your inbox and click the verification link to complete
          your account setup.
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center pt-0">
        <Button
          variant="primary"
          size="lg"
          onClick={onContinue}
          className="px-5"
        >
          Go to Home
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
